<template>
    <div class="documentation">
        <div class="row">
            <div class="col-md-5">
                <Breadcumb title="Ajouter un type d'utilisateur" :breadcumb-data="breadcumbData"></Breadcumb>
            </div>
        </div>
        <b-card class="cardcontainer">
            <b-form @submit="addTypeUser">
                
                <span style="color:#ff0000" v-if="error">{{ error }}</span>
                <b-form-group label="Label" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    
                    <b-input type="text" placeholder="Label" v-model="label"/>
                    <b-alert  v-if="errors['lastname']" show variant="danger">
                        {{ errors['label'][0] }}
                    </b-alert>
                </b-form-group>
                <b-form-group label="Label Anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
        
                    <b-input type="text" placeholder="Label Anglais" v-model="label_en"/>
                    <b-alert  v-if="errors['label_en']" show variant="danger">
                        {{ errors['label'][0] }}
                    </b-alert>
                </b-form-group>
                <b-form-group label="Position" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
        
                    <b-input type="text" placeholder="Position" v-model="position"/>
                    <b-alert  v-if="errors['position']" show variant="danger">
                        {{ errors['label'][0] }}
                    </b-alert>
                </b-form-group>
                <b-form-group label="Permission" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <table class="table table-bordered mb-0">
                        <thead>
                        <tr>
                            <th v-for="service in services">{{service.name}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="service in services">
                            <td>
                                <b-check v-model="user_services[service.slug]"></b-check>
                            </td>
                        </template>
                        </tbody>
                    </table>
                </b-form-group>
                <b-form-row>
                    <div class="col-md-10 ml-md-auto">
                        <b-btn type="submit" variant="primary">Ajouter un type d'utilisateur</b-btn>
                    </div>
                </b-form-row>
            </b-form>
        </b-card>
    </div>
</template>
<script>
    import {
        ADMIN_ADD_USERTYPE_REQUEST,
        ADMIN_GET_USERTYPES_REQUEST
    } from '../../_store/administration/user/actiontypes';
    import Breadcumb from '../../components/breadcumb';
    import { mapState } from 'vuex';

    export default {
        name: 'adminCategoryAdd',
        components: {Breadcumb,},
        mounted() {
            if (this.$route.params.id){
                this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
                    .then(response => {
                        this.userTypesData = response.data.usertypes.forEach(user_type => {
                            console.log(user_type.id);
                            console.log(this.$route.params.id);
                            if (user_type.id == this.$route.params.id){
                                console.log('IM IN');
                                this.label = user_type.label;
                                this.label_en = user_type.label_en;
                                this.position = user_type.position;
                                user_type.services.forEach(service => {
                                    this.user_services[service] = true;
                                })
                                this.$forceUpdate();
                            }
                        });
                    });
            }
        },
        computed: mapState({ errors: state => state.admin_user.errors }),
        data() {
            return ({
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Liste des types d\'utilisateur', href: '/dashboard/administration/usertypelist/'},
                    { text: 'Ajout d\'un type d\'utilisateur', active: true},

                ],
                label: '',
                label_en: '',
                position:0,
                error: false,
                treeData: [],
                lastname: '',
                firstname: '',
                user_services: [],
                services: [
                    {slug: 'documentation', name: 'Espace Documentaire'},
                    {slug: 'companies', name: 'Structure Organisationnelle'},
                    {slug: 'report_deposit', name: 'Dépot de rapport'},
                    {slug: 'report', name: 'Consultation rapport'},
                    {slug: 'softconcept', name: 'SoftConcept'},
                    {slug: 'survey', name: 'Création d\'enquête'},
                    {slug: 'provider', name: 'Prestataire'},
                    {slug: 'user', name: 'Utilisateur'},
                    {slug: 'reporting', name: 'Reporting'},
                    {slug: 'languages', name: 'Multilingue'},
                    {slug: 'roadmap', name: 'Plan d\'actions'}
                ]
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            addTypeUser: function (e) {
                e.preventDefault();
                let services_push = [];
                for (let [key, item] of Object.entries(this.user_services)){
                    if (item === true){
                        services_push.push(key);
                    }
                }
                let id = false;
                if (this.$route.params.id) {
                    id = this.$route.params.id
                }
                this.$store.dispatch(ADMIN_ADD_USERTYPE_REQUEST, {
                    label: this.label,
                    label_en: this.label_en,
                    position: this.position,
                    services: services_push,
                    id: id
                })
                    .then(() => {
                        this.$router.push('/dashboard/administration/usertype/list');
                    })
                    .catch((error) => {
                    
                    });
            }
        }
    };
</script>
